<template>
  <section>
    <div class="popups">
      <b-sidebar
        v-model="showFilters"
        right
        shadow
        backdrop
        bg-variant="white"
        no-header
      >
        <template>
          <div class="container sidebar-header">
            <b-row>
              <div class="col">
                <b-button
                  variant="primary"
                  @click="
                    applyFilters();
                    loadItems();
                    showFilters = false;
                  "
                  >Apply</b-button
                >
              </div>

              <div class="col-auto text-right">
                <b-button
                  type="reset"
                  variant="outline-danger"
                  @click="resetFormFilters()"
                >
                  Reset
                </b-button>
                <b-button
                  variant="outline-secondary"
                  class="ml-1"
                  @click="
                    showFilters = false;
                    formFilters = { ...itemsFilters };
                  "
                >
                  Cancel
                </b-button>
              </div>
            </b-row>
          </div>

          <div class="px-3 py-2">
            <b-form-group label="From Currency:">
              <b-v-select
                v-model="formFilters.fromCurrency"
                :searchable="true"
                :options="currencyFilter"
              />
            </b-form-group>
            <b-form-group label="To Currency:">
              <b-v-select
                v-model="formFilters.toCurrency"
                :searchable="true"
                :options="currencyFilter"
              />
            </b-form-group>
            <b-form-group
              label="From Date:"
              description="From Date must be before To Date"
            >
              <b-form-datepicker
                :reset-button="true"
                v-model="formFilters.startDate"
                class="form-control flatpickr-input"
                placeholder="Select date"
                name="startDate"
              />
            </b-form-group>
            <b-form-group label="To Date:">
              <b-form-datepicker
                :reset-button="true"
                v-model="formFilters.endDate"
                class="form-control flatpickr-input"
                placeholder="Select date"
                name="endDate"
              />
            </b-form-group>
          </div>
        </template>
      </b-sidebar>
    </div>

    <div class="header">
      <div class="header-body">
        <div class="row align-items-end">
          <div class="col">
            <h1 class="header-title">
              Currency Conversion Rate History
            </h1>
            <ActiveFiltersCard :itemsFilters="itemsFilters" :resetFilterWithKey="resetFilterWithKey" :loadItems="loadItems">
              <template v-slot:filterVal(fromCurrency)="data">
                <span v-if="data.item">{{ data.item }}</span>
                <span v-else>-</span>
              </template>
              <template v-slot:filterVal(toCurrency)="data">
                <span v-if="data.item">{{ data.item }}</span>
                <span v-else>-</span>
              </template>
            </ActiveFiltersCard>
          </div>
          <div class="col-auto">
            <b-button variant="primary" @click="showFilters = !showFilters">
              <i class="fa fa-filter mr-2"></i>
              Filters
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <TableListing
      class="mb-0"
      :loading-page="loadingItems"
      :failed-loading="failedLoadItems"
      head-variant="dark"
      :items.sync="items"
      :fields.sync="fields"
      :pagination.sync="pagination"
      :options.sync="tableOptions"
      v-on:pagination-changed="loadItems"
    >
      <template v-slot:cell(conversionDateTimeUtc)="data">
        <span
          v-if="
            data.item.conversionDateTimeUtc &&
              !data.item.conversionDateTimeUtc.endsWith('Z')
          "
          >{{
            (data.item.conversionDateTimeUtc + 'Z') | moment('MMM Do YYYY, h:mm a')
          }}</span
        >
        <span v-else-if="data.item.conversionDateTimeUtc">{{
          data.item.conversionDateTimeUtc | moment('MMM Do YYYY, h:mm a')
        }}</span>
      </template>
      <template v-slot:cell(fromCurrency)="data">
        <span class="badge badge-primary">{{ data.item.fromCurrency }}</span>
      </template>
      <template v-slot:cell(toCurrency)="data">
        <span class="badge badge-success">{{ data.item.toCurrency }}</span>
      </template>
      <template v-slot:cell(conversionRate)="data">
        <span class="font-weight-bold">{{ data.item.conversionRate.toFixed(4) }}</span>
      </template>
      <template v-slot:cell(exchange)="data">
        <div class="text-center">
          <span class="badge badge-primary">1 {{ data.item.fromCurrency }}</span>
          <i class="fa fa-arrow-right mx-2"></i>
          <span class="badge badge-success">{{ data.item.conversionRate.toFixed(4) }} {{ data.item.toCurrency }}</span>
        </div>
      </template>
      <template v-slot:cell(createDateTimeUtc)="data">
        <span
          v-if="
            data.item.createDateTimeUtc &&
              !data.item.createDateTimeUtc.endsWith('Z')
          "
          >{{
            (data.item.createDateTimeUtc + 'Z') | moment('MMM Do YY, h:mm a')
          }}</span
        >
        <span v-else-if="data.item.createDateTimeUtc">{{
          data.item.createDateTimeUtc | moment('MMM Do YY, h:mm a')
        }}</span>
      </template>
    </TableListing>
  </section>
</template>

<script>
import ActiveFiltersCard from '@/views/components/ActiveFiltersCard.vue';
import TableListing from '@/views/components/TableListing.vue';
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';

export default {
  name: 'Billing.ConversionRateHistoricalRecords.Index',
  mixins: [crudMixinGen('billing/conversionRateHistoricalRecords'), myCommonDataMixin],
  components: {
    ActiveFiltersCard,
    TableListing
  },
  computed: {
  },

  data: () => ({
    currencyFilter: [
      {value: 'USD', text: 'USD - US Dollar'},
      {value: 'EUR', text: 'EUR - Euro'},
      {value: 'GBP', text: 'GBP - British Pound'},
      {value: 'CAD', text: 'CAD - Canadian Dollar'},
      {value: 'AUD', text: 'AUD - Australian Dollar'},
      {value: 'JPY', text: 'JPY - Japanese Yen'},
      {value: 'CHF', text: 'CHF - Swiss Franc'},
      {value: 'CNY', text: 'CNY - Chinese Yuan'},
      {value: 'INR', text: 'INR - Indian Rupee'},
      {value: 'MXN', text: 'MXN - Mexican Peso'}
    ],
    fields: [
      { key: 'conversionDateTimeUtc', label: 'Conversion Date', sortable: false },
      { key: 'fromCurrency', label: 'From Currency', sortable: false },
      { key: 'toCurrency', label: 'To Currency', sortable: false },
      { key: 'conversionRate', label: 'Rate', sortable: false },
      { key: 'exchange', label: 'Exchange', sortable: false }
    ]
  }),
  mounted() {
    let queryHas = this.$route.query;
    if (queryHas) {
      this.resetFormFilters();
      this.formFilters = Object.assign(this.itemsFilters, queryHas);
      this.itemsFilters = Object.assign(this.itemsFilters, queryHas);
    } else {
      this.resetFormFilters();
    }
    this.loadItems();
  },

  methods: {
  }
};
</script>